import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['María', 'Camila', 'Florencia', 'Sofía', 'Valentina', 'Julieta', 'Martina', 'Luciana', 'Agustina', 'Carolina', 'Daniela', 'Paula', 'Natalia', 'Gabriela', 'Andrea'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bogotá', 'Lima', 'Santiago', 'Montevideo', 'Medellín', 'Guadalajara', 'Quito', 'Asunción'];
function getRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [person, setPerson] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setPerson({
        name: getRandom(names),
        city: getRandom(cities)
      });
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    };
    const initialTimeout = setTimeout(showPopup, 10000);
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-223">
      {visible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 120,
      damping: 18
    }} className="fixed top-4 left-4 z-50 max-w-xs" data-id="element-224">
          <a href="#compra" className="block" data-id="element-225">
            <div className="bg-[#1A0A2E] border border-brand-magenta/30 rounded-2xl p-4 shadow-2xl shadow-brand-magenta/10" data-id="element-226">
              <div className="flex items-center gap-3" data-id="element-227">
                <div className="w-10 h-10 rounded-full bg-brand-magenta/20 flex items-center justify-center text-lg flex-shrink-0" data-id="element-228">
                  🛒
                </div>
                <div data-id="element-229">
                  <p className="text-white text-sm font-semibold leading-tight" data-id="element-230">
                    {person.name} de {person.city}
                  </p>
                  <p className="text-brand-muted text-xs mt-0.5" data-id="element-231">
                    acaba de comprar el Método pH-ZERO
                  </p>
                  <p className="text-brand-teal text-[10px] mt-1" data-id="element-232">
                    Hace unos momentos
                  </p>
                </div>
              </div>
            </div>
          </a>
        </motion.div>}
    </AnimatePresence>;
}